import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BrandMark } from "@/components/Brand";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6 text-center" data-testid="payment-cancel">
      <div className="mb-6">
        <BrandMark className="h-14 w-14 object-contain mx-auto" />
      </div>
      <XCircle className="h-10 w-10 text-muted-foreground mx-auto mb-3" />
      <p className="font-heading text-2xl text-foreground">Checkout cancelled</p>
      <p className="text-muted-foreground mt-1 max-w-sm">
        No charge was made. You can subscribe whenever you're ready.
      </p>
      <Button onClick={() => navigate("/billing", { replace: true })}
        className="rounded-full mt-6 bg-primary hover:bg-primary/90 text-primary-foreground" data-testid="cancel-back-billing">
        Back to billing
      </Button>
    </div>
  );
}
